import api from './client'; 
const getAdminPassword = () => sessionStorage.getItem('adminPass') || '';


export const getFollowRequests = () =>
  api.get('/api/social/requests/pending').then(res => res.data);

export const acceptFollowRequest = (requesterId) =>
  api.post(`/api/social/requests/accept/${requesterId}`).then(res => res.data);

export const rejectFollowRequest = (requesterId) =>
  api.post(`/api/social/requests/reject/${requesterId}`).then(res => res.data);


  export const toggleProfilePrivacy = () =>
  api.patch('/users/me/privacy').then(res => res.data);

  export const cancelFollowRequest = (targetId) =>
  api.delete(`/api/social/requests/cancel/${targetId}`).then(res => res.data);

  export const followUser = (targetId) => 
  api.post(`/api/social/follow/${targetId}`).then(res => res.data);

export const unfollowUser = (targetId) => 
  api.delete(`/api/social/unfollow/${targetId}`).then(res => res.data);

export const removeFollower = (followerId) =>
  api.delete(`/api/social/followers/remove/${followerId}`).then(res => res.data);